import React from 'react';

import type { VinkStoryTag } from '@schibsted/frapi-schema';

const BundleHeader: React.FC<{ story: VinkStoryTag }> = ({ story }) => {
  return (
    <div className="bundle-header">
      <div className="bundle-title-wrapper">
        {story && <div className="bundle-title">{story.title}</div>}
      </div>
    </div>
  );
};

export default BundleHeader;
